import React, { forwardRef } from 'react'

export type MessageProps = React.ComponentProps<'div'>

const Message = forwardRef<HTMLDivElement, MessageProps>(({ className = '', children, ...rest }, ref) => (
  <div ref={ref} className={`Message flex ${className}`} {...rest}>
    <p className='text-left rounded-24 rounded-tl-8 border-2 bg-tertiary border-secondary p-16 antialiased font-normal leading-relaxed text-16 lg:text-18'>
      {children}
    </p>
  </div>
))

export default Message
